import { classNames } from "@opensea/ui-kit"

export const CREATE_OFFER_FLOW_TABLE_CLASSNAMES = {
  item: classNames("grow first:pl-0"),
  floor: classNames("hidden w-[120px] justify-end md:flex"),
  bestOffer: classNames("hidden w-[120px] justify-end md:flex"),
  cost: classNames("hidden w-[120px] justify-end md:flex"),
  proceeds: classNames("hidden w-[120px] justify-end md:flex"),
  price: classNames("w-[150px] justify-end last:pr-0"),
  remove: classNames("w-[28px]"),
}
